import { render, staticRenderFns } from "./SalaryInquiryAddBtn.vue?vue&type=template&id=c727b7a6&"
import script from "./SalaryInquiryAddBtn.vue?vue&type=script&lang=js&"
export * from "./SalaryInquiryAddBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports